module.exports = __webpack_public_path__ + "static/media/banner-logado-desktop.d7cec3dd.webp";